module.exports = __webpack_public_path__ + "img/lavietoronto.77433011.png";